import React from "react";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/images/logos/Logo1_notext.png";

export const HomeQualitySection = () => {
  const { t } = useTranslation();

  return (
    <section className="quality-section">
      <div className="header">
        <img width={60} height={60} src={Logo} alt="VH BuildUp! Logo" />
        <h1>{t("home.quality_section.title")}</h1>
        <p className="quote">
          “Whatever you do, do it well. Do it so well that when people see you
          do it they will want to come back and see you do it again and they
          will want to bring others and show them how well you do what you do."
          (Walt Disney)
        </p>
      </div>
      <div className="content">
        <div>
          <h1>{t("home.quality_section.responsibility.title")}</h1>
          <br />
          <p>{t("home.quality_section.responsibility.description")}</p>
        </div>
        <div>
          <h1>{t("home.quality_section.quality.title")}</h1>
          <br />
          <p>{t("home.quality_section.quality.description")}</p>
        </div>
        <div>
          <h1>{t("home.quality_section.service.title")}</h1>
          <br />
          <p>{t("home.quality_section.service.description")}</p>
        </div>
      </div>
    </section>
  );
};
